import { atomWithStorage, createJSONStorage } from "jotai/utils";

export interface OnboardingState {
  welcomeModalShown: boolean;
  completedAt: string | null;
}

// Custom storage that reads synchronously on init to prevent flickering
const storage = createJSONStorage<OnboardingState>(() => localStorage);

// Read initial value synchronously from localStorage
function getInitialValue(): OnboardingState {
  const defaultValue: OnboardingState = {
    welcomeModalShown: false,
    completedAt: null,
  };

  if (typeof window === "undefined") return defaultValue;

  try {
    const stored = localStorage.getItem("tabitto-onboarding");
    if (stored) {
      return JSON.parse(stored) as OnboardingState;
    }
  } catch {
    // Ignore parse errors
  }
  return defaultValue;
}

// Persisted onboarding state (saved to localStorage)
// Using getInitialValue() ensures the correct state on first render
export const onboardingAtom = atomWithStorage<OnboardingState>(
  "tabitto-onboarding",
  getInitialValue(),
  storage
);
